import { useEffect, useRef } from 'react';

/**
 * « Le statut des missions a pu bouger côté serveur » — un signal, pas une donnée.
 *
 * Un geste humain peut faire avancer une mission sans passer par sa carte : envoyer
 * depuis le Hub une réponse sur le fil d'une mission qui attendait Gilles la remet en
 * marche (`gmail-send` → `answerMissionsForOutboundEmails`). Chaque lecteur de mission
 * de la messagerie (bande « Otto t'attend », pastilles de la liste, carte de mission)
 * charge une fois au montage : sans ce signal, ils affichaient encore « Otto t'attend »
 * après l'envoi, jusqu'au rechargement de la page (constaté le 14/09/2026).
 *
 * Le signal ne transporte rien : chaque lecteur relit SA source serveur (principe 11).
 */
const MISSIONS_CHANGED_EVENT = 'missions:changed';

export function notifyMissionsChanged(): void {
  window.dispatchEvent(new Event(MISSIONS_CHANGED_EVENT));
}

/** Écoute hors React (un lecteur partagé au niveau du module) ; rend la désinscription. */
export function onMissionsChanged(handler: () => void): () => void {
  window.addEventListener(MISSIONS_CHANGED_EVENT, handler);
  return () => window.removeEventListener(MISSIONS_CHANGED_EVENT, handler);
}

/** Rappelle `onChange` à chaque signal ; le dernier callback rendu est toujours celui appelé. */
export function useOnMissionsChanged(onChange: () => void): void {
  const latest = useRef(onChange);
  useEffect(() => { latest.current = onChange; }, [onChange]);

  useEffect(() => {
    return onMissionsChanged(() => latest.current());
  }, []);
}
